import { render, staticRenderFns } from "./PropertiesCatalogTable.vue?vue&type=template&id=01985c73"
import script from "./PropertiesCatalogTable.vue?vue&type=script&lang=js"
export * from "./PropertiesCatalogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports